import React from 'react';
import classNames from 'classnames';

import LoadingSpinner from '../../shared/LoadingSpinner';
import Appointment from './Appointment';
import styles from './AvailableAppointments.css';

const Results = ({ appointments, loading, onBidClick, ...props }) => 
{
  
  return(  
  <div className="panel panel-default" {...props}>
    <div className={classNames('panel-body', styles.searchResultsContainer)}>
      {loading && <LoadingSpinner />}
      {appointments.map((a) => (
        <Appointment                    
          appointment={a}
          key={a.id}          
          onClick={() => onBidClick(a.id)}
          color={'#0f0'}
          
        />
      ))}
    </div>
  </div>
);}

export default Results;
